import Header from '@/components/public/Header'
import Footer from '@/components/public/Footer'
import SubTitle from '@/components/public/subtitle'
import SubFooter from '@/components/public/subfooter'
import HeaderNav from '@/components/public/headerNav'
import TypeNav from '@/components/public/typeNav'
import BackTop from '@/components/public/backTop'

export default {
  components: {
    Header,
    Footer,
    HeaderNav,
    SubTitle,
    SubFooter,
    TypeNav,
    BackTop
  }
}




// WEBPACK FOOTER //
// ./src/mixin/index.js